export const formatDuration = (durationInMillis?: number) => {
    if (!durationInMillis || durationInMillis <= 0) return "0 min";

    const totalMinutes = Math.max(1, Math.round(durationInMillis / 60_000));
    const days = Math.floor(totalMinutes / 1_440);
    const hours = Math.floor((totalMinutes % 1_440) / 60);
    const minutes = totalMinutes % 60;

    if (days > 0) return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
    if (hours > 0) return minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`;
    return `${minutes}min`;
};

export const getInitials = (name?: string) => {
    if (!name) return "?";
    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase();
};
